import { exists } from '@/api'

export interface MarcTag {
  tag: string
  labelName: string
  repeat: boolean
  menuDisplay: number
  displayOrder: number
  fieldType: string
  maxLength: number
  systemCodeKey: string
}

export function MarcTagFromJSON(json: any): MarcTag {
  return {
    tag: exists(json, 'tag') ? json.tag : '',
    labelName: exists(json, 'label_name') ? json.label_name : '',
    repeat: exists(json, 'repeat') ? json.repeat : false,
    menuDisplay: exists(json, 'menu_display') ? json.menu_display : 1,
    displayOrder: exists(json, 'display_order') ? json.display_order : 1,
    fieldType: exists(json, 'field_type') ? json.field_type : '',
    maxLength: exists(json, 'max_length') ? json.max_length : 0,
    systemCodeKey: exists(json, 'system_code_key') ? json.system_code_key : ''
  }
}
